module.exports = __webpack_public_path__ + "img/bg-sign-in.c70df343.png";